import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import Router from "../const/router";
// Pages
import HomePage from "../pages/HomePage";
import AdminPage from "../pages/AdminPage";
import AdminServicesPage from "../pages/AdminPage/nesteds/AdminServicesPage";
import AdminSkillsPage from "../pages/AdminPage/nesteds/AdminSkillsPage";
import AdminWorksPage from "../pages/AdminPage/nesteds/AdminWorksPage";
import NotFoundPage from "../pages/NotFoundPage";
import WorksPage from "../pages/WorksPage";

const AppRouter = () => {
  const { isLoged } = useSelector((state) => state.auth);
  return (
    <Routes>
      <Route path={Router.ADMIN} element={<AdminPage />} />
      {isLoged && (
        <>
          <Route path={Router.ADMIN_SERVICES} element={<AdminServicesPage />} />
          <Route path={Router.ADMIN_SKILLS} element={<AdminSkillsPage />} />
          <Route path={Router.ADMIN_WORKS} element={<AdminWorksPage />} />
        </>
      )}
      <Route path={Router.HOME} element={<HomePage />} />
      <Route path={Router.WORKS} element={<WorksPage />} />
      <Route path={Router.NOT_FOUND} element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRouter;
